<template>
  <div class="toast"
       v-show="visible">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      message: '', // 消息文字
      duration: 1200, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器
      visible: false, // 是否显示
    }
  },
  mounted() {
    this.startTimer()
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false
        this.destroyElement()
      }
    },
  },
  methods: {
    destroyElement() {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    startTimer() {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true
          clearTimeout(this.timer)
        }
      }, this.duration)
    },
  },
}
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3D(-50%, -50%, 0);
  min-width: 200/75rem;
  // height: 80/75rem;
  padding: 10/75rem 30/75rem;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
  // line-height: 80/75rem;
  font-size: 28/75rem;
  border-radius: 6/75rem;
  padding: 20/75rem;
}
@media (min-width: 1600/75rem) {
  .toast {
    font-size: 28/75rem;
  }
}
@media (min-width: 1200/75rem) and(max-width:1599/75rem) {
  .toast {
    font-size: 28/75rem;
  }
}
@media screen and(max-width:1199/75rem) {
  .toast {
    font-size: 28/75rem;
  }
}
</style>